import { useState } from 'react'
import { Dialog } from './'
import { Avatar, Box, H3 } from '../'
import './AvatarDialog.scss'

export const AvatarDialog = ({ value, onChange, onClose, mode, ...props }) => {
  const [selectedAvatar, setSelectedAvatar] = useState(value)

  const selectAvatar = index => {
    setSelectedAvatar(index)
    onChange?.(index)
  }

  const createAvatarsList = (size, className, dark) => <div className={className + ' wrap-list'}>
    {Array.from({ length: 6 }).map((_, index) =>
      <Avatar
        key={index}
        index={index}
        selectable
        size={size}
        mode={mode}
        dark={dark}
        selected={selectedAvatar === index}
        onClick={() => selectAvatar(index)}
      />)}
  </div>

  return <Dialog {...props} onClose={() => onClose(selectedAvatar)}>
    <Box column className="avatar-dialog-content">
      <H3 align="center" className="avatar-title">Choose avatar</H3>
      {createAvatarsList('small', 'mobile-only', false)}
      {createAvatarsList('medium', 'desktop-only', true)}
    </Box>
  </Dialog>
}